/*
    Creates new users and adds them to existing groups, assigns admin's bucketName to the user
*/

import React, { useState } from 'react';
import { TextField, FormControl, IconButton, InputAdornment, Typography, Box } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CustomButton from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { createUser } from '../utils/apiClient';

function AddUser() {
    const [showPassword, setShowPassword] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    async function handleSubmit(event) {
        event.preventDefault();
        if (!firstName || !lastName || !email) {
            alert('Please fill in all fields');
            return;
        }

        try {
            await createUser(email, firstName, lastName);
            alert('User created successfully');
            navigate('/team');
        } catch (error) {
            console.error('Error creating user:', error);
            alert('Failed to create user. Please check the details and try again.');
        }
    }

    return (
        <div className="container">
            <div className="AddUserDiv">
                <FormControl fullWidth>
                    <Typography 
                        variant="h5" 
                        gutterBottom 
                        align="center"
                    >
                        Add New User
                    </Typography>
                    <Box display="flex" gap={2} marginBottom={2}>
                        <TextField
                            name="firstName"
                            type="text"
                            variant="outlined"
                            placeholder="First Name"
                            fullWidth
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            sx={{ backgroundColor: 'white', borderRadius: '5px' }}
                        />
                        <TextField
                            name="lastName"
                            type="text"
                            variant="outlined"
                            placeholder="Last Name"
                            fullWidth
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            sx={{ backgroundColor: 'white', borderRadius: '5px' }}
                        />
                    </Box>
                    <TextField
                        name="email"
                        type="text"
                        variant="outlined"
                        placeholder="Email ID"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ marginBottom: 2, backgroundColor: 'white', borderRadius: '5px' }}
                    />
                    <CustomButton onClick={handleSubmit} text="Add User" sx={{ marginTop: 2 }} />
                </FormControl>
            </div>
        </div>
    );
}

export default AddUser;
